// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__17NpM","inputWrap":"styles_inputWrap__2Flvu","input":"styles_input__1U9qs"};